<template>
  <div :class="'sp-' + sitedata.settings[0].blockseparator + ' page-featureitem page-' + mainpage.blockstyle" :id="sitecontainer">
    <main-nav v-if="!isfeaturedetail" :websiteid="websiteid" :readonly="readonly" :creatoreditor="creatoreditor" :creatorhome="creatorhome" :sitedata="sitedata" :mainpageid="mainpageid"/>
    <home v-if="creatorhome" :content="sitedata" :homeimage="sitedata.mainblockimage"/>
    
    <!-- homeblock or normal block -->
    <home-block :tutorialStepCount="tutorialStepCount" @clicked="tutorialStep" :websiteid="websiteid" :readonly="readonly" v-if="!pageslug && !creatorhome" :content="sitedata" :homeimage="sitedata.mainblockimage" :style="'background-color: '+ sitedata.settings[0].bghero +'; color: '+ sitedata.settings[0].texthero"/>

    <feature-detail isfeaturedetail="isfeaturedetail" v-if="isfeaturedetail" :readonly="readonly" :pageid="mainpage._id" :websiteid="websiteid" :isfeaturedetail="isfeaturedetail" :sitedata="sitedata" />
    <section-block :websiteid="websiteid" :readonly="readonly" v-if="pageslug && !isfeaturedetail" class="block-invert first-block" :content="mainpage" :sitedata="sitedata"  :cantdelete="true" @clicked="getPages"/>
    <!--breadcrumb v-if="pageslug" :pageslug="pageslug" :belongsto="mainpage.belongsto"/-->
    <!-- all other blocks -->
    <section-block :websiteid="websiteid" :key="index" :readonly="readonly" v-for="(block, index) in orderedPages" :sitedata="sitedata" :id="block.pageslug" :content="block" :class="{'block-odd': index % 2, 'block-invert': block.blockimage != null && block.blockimagestyle == 'imgbg'}" @clicked="getPages"/>

    <!-- add a page -->
    <page-adder :websiteid="websiteid" v-if="!readonly && !isfeaturedetail" :parentpageid="mainpageid" :content="sitedata" @clicked="getPages"/>

    <!-- footer -->
    <main-footer v-if="!isfeaturedetail" @clicked="toggleReadOnly" :websiteid="websiteid" :readonly="readonly" :creatoreditor="creatoreditor" :creatorhome="creatorhome" :sitedata="sitedata" :mainpageid="mainpageid"/>

    <tutorial :websiteid="websiteid" @clicked="tutorialStep" v-if="!creatorhome  && !isfeaturedetail && sitedata.hastutorial" :tutorialStepCount="tutorialStepCount" :sitedata="sitedata"/>
  </div>
</template>

<script>
  import InputDefault from '../components/form/InputDefault.vue';
  import FeatureDetail from '../components/content/FeatureDetail.vue';
  import Tutorial from '../components/app/Tutorial.vue';
  import AlertBar from '../components/form/Alert.vue';
  import Loader from '../components/ui/Loader.vue';
  import MainNav from '../components/navigation/MainNav.vue';
  import MainFooter from '../components/navigation/MainFooter.vue';
  import HomeBlock from '../components/content/HomeBlock.vue';
  import SectionBlock from '../components/content/SectionBlock.vue';
  import PageAdder from '../components/app/PageAdder.vue';
  import VacanciesHome from '../components/content/VacanciesHome.vue';
  import _ from 'lodash';
  import Home from './Home.vue';

  import axios from 'axios';

  import { userService } from '../services/user.service.js';

  export default {
    components: {
      InputDefault,
      FeatureDetail,
      Tutorial,
      AlertBar,
      Loader,
      MainNav,
      HomeBlock,
      SectionBlock,
      PageAdder,
      MainFooter,
      VacanciesHome,
      Home
    },
    created(){
    },
    props:{
      isfeaturedetail: {
        type: Boolean
      },
      websiteid: {
        type: String
      },
      readonly: {
        type: Boolean
      },
      creatorhome: {
        type: Boolean
      },
      creatoreditor: {
        type: Boolean
      }
    },
    data: function (){
      return {
        msgtext: '',
        msgclass: 'error',
        username: '',
        password: '',
        submitted: false,
        loading: false,
        loggingin: false,
        returnUrl: '',
        error: '',
        pages: {},
        mainpage: '',
        pageslug: this.$route.params.pageslug,
        mainpageid: 'home',
        pagetitle: '',
        customsheet: '',
        linkcolor: '',
        linkcolordark: '',
        buttoncolor: '',
        buttoncolor2: '',
        logoheight: '',
        logoheightscroll: '',
        headerstyle: '',
        menucolor: '',
        menulinkcolors: '',
        sitedata: {
          settings: [{}],
        },
        tutorialStepCount: 0,
        sitecontainer: ''
      }
    },
    computed: {
      orderedPages: function () {
        return _.orderBy(this.pages, 'order', 'desc')
      }
    },
    methods: {
        tutorialStep(step){
          this.tutorialStepCount = step
        },
        toggleReadOnly(){
          this.readonly = !this.readonly
          if(this.readonly == true){
            this.sitecontainer = ''
          } else {
            this.sitecontainer = 'sitecontainer'
          }
        },
        getMainPage(pageslug){
          axios.get(process.env.VUE_APP_ROOT_API+'/pages/'+this.websiteid+'/pageslug/'+this.pageslug)
            .then(response => {
                this.mainpage = response.data.response
                this.mainpageid = response.data.response._id
                this.pagetitle = response.data.response.pagetitle
                this.getPages()
            })
        },
        getSiteData(){
            axios.get(process.env.VUE_APP_ROOT_API+'/settings/'+this.websiteid)
            .then(response => {
                this.sitedata = response.data.response
            })
            if(this.creatoreditor){
              this.sitecontainer = 'sitecontainer'
            }
        },
        getPages(){
            const pageid = ''

            if(this.$route.params.pageslug){
              //get pageid first
              this.pageid = this.mainpageid
            } else {
              this.pageid = 'home'
            }

            axios.get(process.env.VUE_APP_ROOT_API+'/pages/'+this.websiteid+'/'+this.pageid)
            .then(response => {
                this.pages = response.data.response
            })
        },
    },
    mounted(){
        if(this.$route.params.pageslug){
          // is a page
          this.getMainPage(this.$route.params.pageslug)
        } else {
          // is a homepage
          this.getPages()
          this.complement = this.sitedata.name
        }
        this.getSiteData()
    },
    // Usage with context the component
    head: {
      // To use "this" in the component, it is necessary to return the object through a function
      title: function () {
        
        if(this.$route.params.pageslug){
          // is a page
          return {
            inner: this.sitedata.name,
            separator: '-',
            complement: this.pagetitle
          }
        } else {
          // is a homepage
          if(this.sitedata.settings[0].site_title){
            return {
              inner: this.sitedata.name,
              separator: '-',
              complement: this.sitedata.settings[0].site_title
            }
          } else {
            return {
              inner: this.sitedata.name,
              separator: ' '
            }
          }
        }
      },
      style: function () {
        if(this.sitedata.settings[0].use_stylesheet == true){
          this.custom_sheet = this.sitedata.settings[0].custom_stylesheet
        }
        if(this.sitedata.settings[0].linkcolor){
          this.linkcolor = 'a{color: '+this.sitedata.settings[0].linkcolor+'} '
        }
        if(this.sitedata.settings[0].linkcolordark){
          this.linkcolordark = '.block-invert a:not(.btn), .block-invert a:not(.btn):hover, .navbar-dark .navbar-nav .nav-link.active, .nav-social a:hover, .navbar-dark .navbar-nav .nav-link:hover, .block-invert .footer-nav > ul > li > a.active{color: '+this.sitedata.settings[0].linkcolordark+'} '
        }
        if(this.sitedata.settings[0].buttoncolor){
          this.buttoncolor = '.btn-primary{background: '+this.sitedata.settings[0].buttoncolor+' !important} '
        }
        if(this.sitedata.settings[0].buttoncolor == '#ffffff'){
          this.buttoncolor2 = '.btn-primary{color: #000000 !important} '
        }
        if(this.sitedata.settings[0].logoheight){
          this.logoheight = '.logoimage{max-height: none; height: '+this.sitedata.settings[0].logoheight+'px} '
        }
        if(this.sitedata.settings[0].logoheightscroll){
          this.logoheightscroll = '.moving-nav .logoimage{max-height: none; height: '+this.sitedata.settings[0].logoheightscroll+'px} '
        }
        if(this.sitedata.settings[0].menucolor){
          this.menucolor = '#mainnavselection{background-color: '+this.sitedata.settings[0].menucolor+'} '
        }
        if(this.sitedata.settings[0].menucolortheme == 'light'){
          this.menulinkcolors = '.navbar-dark .navbar-nav .nav-link.active{color: '+this.sitedata.settings[0].linkcolordark+'; opacity: 1;} .nav-social a, .nav-social a:hover, .navbar-dark .navbar-nav .nav-link:hover{color: '+this.sitedata.settings[0].linkcolordark+';} '
        } else {
          this.menulinkcolors = '.nb-dark .navbar-dark .navbar-nav .nav-link.active{color: '+this.sitedata.settings[0].linkcolor+'; opacity: 1;} .nb-dark .nav-social a, .nb-dark .nav-social a:hover, .nb-dark .navbar-dark .navbar-nav .nav-link:hover{color: '+this.sitedata.settings[0].linkcolor+';} '
        }
        if(this.sitedata.settings[0].fontstyle == 'serif'){
          this.headerstyle = '.display-1, .display-2, .display-3, .display-4, .display-5, .btn{font-family: "Bitter"; font-weight: 800; zoom: .9} '
        } else if (this.sitedata.settings[0].fontstyle == 'regular'){
          this.headerstyle = '.display-1, .display-2, .display-3, .display-4, .display-5, .btn{font-family: "Roboto"; font-weight: 500;} '
        } else if (this.sitedata.settings[0].fontstyle == 'business'){
          this.headerstyle = '.display-1, .display-2, .display-3, .display-4, .display-5, .btn{font-family: "Roboto"; font-weight: 300;} '
        } else if (this.sitedata.settings[0].fontstyle == 'bold'){
          this.headerstyle = '.display-1, .display-2, .display-3, .display-4, .display-5, .btn{font-family: "Roboto"; font-weight: 900;} '
        } else if (this.sitedata.settings[0].fontstyle == 'caps'){
          this.headerstyle = '.display-1, .display-2, .display-3, .display-4, .display-5, .btn{font-family: "Roboto"; font-weight: 900; zoom: 1.2; letter-spacing: -.05em; text-transform: uppercase;} '
        }
        return [
          {
            type: 'text/css',
            inner: this.linkcolor + this.linkcolordark + this.buttoncolor + this.buttoncolor2 + this.logoheight + this.logoheightscroll + this.menucolor + this.menulinkcolors + this.headerstyle + this.custom_sheet
          }
        ]
      },
      meta: function () {
        if(this.$route.params.pageslug){
          // is a page
          if(this.mainpage.seodesc){
            return [
              {
                name: 'description',
                content: this.mainpage.seodesc
              }
            ]
          } else {
            return [
              {
                name: 'description',
                content: this.mainpage.pagetext
              }
            ]
          }
        } else {
          // is homepage
          // is a page
          if(this.sitedata.settings[0].site_description){
            return [
              {
                name: 'description',
                content: this.sitedata.settings[0].site_description
              }
            ]
          } else {
            return [
              {
                name: 'description',
                content: this.sitedata.tagline
              }
            ]
          }
        }
      },
      link: function () {
        const fontstyle = ''

        if(this.sitedata.settings[0].googlefont){
          this.fontstyle = this.sitedata.settings[0].googlefont
        } else {
          if(this.sitedata.settings[0].fontstyle == 'regular'){
            this.fontstyle = 'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700'
          } else if(this.sitedata.settings[0].fontstyle == 'friendly'){
            this.fontstyle = 'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700|Varela+Round'
          } else if(this.sitedata.settings[0].fontstyle == 'business'){
            this.fontstyle = 'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700'
          } else if(this.sitedata.settings[0].fontstyle == 'serif'){
            this.fontstyle = 'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700|Bitter:700,800'
          } else if(this.sitedata.settings[0].fontstyle == 'bold'){
            this.fontstyle = 'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700'
          } else if(this.sitedata.settings[0].fontstyle == 'caps'){
            this.fontstyle = 'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900'
          } else {
            this.fontstyle = 'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700|Varela+Round'
          }
        }

        const returnarray = []
        
        returnarray.push({
          rel: 'stylesheet',
          href: this.fontstyle
        })
        
        if(this.sitedata.settings[0].theme != 'default'){
          returnarray.push({
            rel: 'stylesheet',
            href: process.env.VUE_APP_ROOT_STATIC + '/' + this.sitedata.settings[0].theme + '.css'
          })
        }

        if(this.mainpage.seocanon){
          returnarray.push({
            rel: 'canonical',
            href: this.mainpage.seocanon
          })
        }

        if(this.sitedata.settings[0].favicon){
          returnarray.push(
          {
            rel: 'icon',
            href: this.sitedata.settings[0].favicon,
            size: '32x32'
          }, 
          {
            rel: 'icon',
            href: this.sitedata.settings[0].favicon,
            size: '192x192'
          }, 
          {
            rel: 'apple-touch-icon-precomposed',
            href: this.sitedata.settings[0].favicon
          }, 
          {
            rel: 'msapplication-TileImage',
            href: this.sitedata.settings[0].favicon
          })
        }
      
        return returnarray
      }
    },
    watch: {
      sitedata: {
        handler(sitedata) {
          this.$emit('updateHead')

          if (this.sitedata.settings && this.sitedata.settings[0].use_analytics) {
            var gascript = document.createElement("script");
            gascript.innerHTML = "window.ga=window.ga||function(){(ga.q=ga.q||[]).push(arguments)};ga.l=+new Date; ga('create', '"+this.sitedata.settings[0].code_analytics+"', 'auto'); ga('send', 'pageview');";
            document.body.appendChild(gascript);
            var gascript2 = document.createElement('script');    
            gascript2.setAttribute('src',"https://www.google-analytics.com/analytics.js");
            gascript2.setAttribute('async',"true");
            document.body.appendChild(gascript2);
          }

        },
        immediate: true
      }
    }
  }
</script>

<style>
</style>
